module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921035649_T.b1c4180b.jpg";